module.exports = __webpack_public_path__ + "img/sierraint6.71e2dd90.png";